import { inject, Injectable, LOCALE_ID } from "@angular/core";

import { CardViewModel } from "../models/card.vm";
import { AppService } from "../app.service";
import { ApiGetResult } from "@upupa/data";
import { ICaseStudyForm } from "@in2/models";

export type CaseStudyViewModel = CardViewModel & {
    cardDescription?: string;
} & Record<string, any>;

@Injectable({ providedIn: "root" })
export class CaseStudiesService {
    private readonly contentService = inject(AppService);
    private readonly locale = inject(LOCALE_ID);
    async list(excludeBySlug?: string[]): Promise<Partial<ApiGetResult<ICaseStudyForm[]>>> {
        const q = {
            lang: this.locale,
            select: "title,slug,image,description",
            status: "published",
            sort_by: "publishedAt,desc",
        };
        if (excludeBySlug?.length) {
            q["slug"] = `{nin}${excludeBySlug}`;
        }

        return this.contentService.fetchJsonAsset<Partial<ICaseStudyForm[]>>(`caseStudy`, q);
    }
}
